import { yup } from 'utils/yup';

export const DEFAULT_REGISTERED_BUSINESS_ADDRESS_COUNTRY = 'United States';
export const DEAFULT_US_PHONE_CODE = '+1';
export const MAX_ZIP_CODE_FOR_NON_US = 8;
export const MAX_ZIP_CODE_FOR_US = 5;
export const CONFIRM_VENDOR_MESSAGE = 'This action will add the vendor. Are you sure?';
export const MERGE_VENDOR_MESSAGE = 'This action will merge the selected vendor with the added vendor. Are you sure?';

//Alert messages
export const VENDOR_MERGED_SUCCESSFULLY = 'Vendor merged successfully.';
export const VENDOR_ADDDED_SUCCESSFULLY = 'Vendor added successfully.';

export const SEARCH_VENDOR_FORM_DEFAULT_VALUE = {
  VendorOrgName: '',
  DomainName: '',
  NumberOfSearchResults: '',
};

export const SEARCH_VENDOR_SCHEMA = yup.object({
  VendorOrgName: yup.string().trim().required('* Required'),
  DomainName: yup.string().trim().required('* Required').domain('Domain Name should be valid'),
  NumberOfSearchResults: yup.string(),
});

export type SearchVendorFormValues = yup.InferType<typeof SEARCH_VENDOR_SCHEMA>;
